import {
    ApiShopperLandingPage,
    GetExternalLandingPageProductsResponse,
    SharedApiLandingPageLinkData,
} from '@storefronts/common-types'

export function applyHydratedLandingPageProducts(
    landingPage: ApiShopperLandingPage,
    payload: GetExternalLandingPageProductsResponse,
): ApiShopperLandingPage {
    const sharedProductData = mergeSharedProductData(
        landingPage.sharedProductData,
        payload.sharedProductData,
    )
    return {
        ...landingPage,
        products: {
            ...landingPage.products,
            ...payload.products,
        },
        ...(sharedProductData != null ? { sharedProductData } : {}),
    }
}

function mergeSharedProductData(
    ssr?: Record<string, SharedApiLandingPageLinkData>,
    hydrated?: Record<string, SharedApiLandingPageLinkData>,
): Record<string, SharedApiLandingPageLinkData> | undefined {
    if (ssr == null && hydrated == null) return undefined
    const merged = { ...ssr, ...hydrated }
    return Object.keys(merged).length > 0 ? merged : undefined
}
